import React, { useEffect, useRef } from 'react'
import ProductForm from './ProductForm';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import productServices from '../productServices';

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => `${option.title} ${option.details} ${option.hsn} ${option.model} ${option.sku}`,
});

function SelectProduct({callBack, options, selectedProduct, setSelectedProduct}) {

  const {getProductList, getProductDD} = useAppData();

  const focusInputRef = useRef(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (focusInputRef.current) {
        focusInputRef.current.focus();
      }
    }, 100); 

    return () => clearTimeout(timer);
  }, []);

  const onCreateNew = (productId) =>{
    productServices.getById(productId).then(res=>{
      console.log(res.data);
      setSelectedProduct(res.data);
      getProductList();
      getProductDD();
    }).catch(error=>{
      console.log(error)
    })
  }


  //console.log(options)

  return (
    <div className='row'>
      <div className='col-md-6'>
        <Autocomplete
            options={options}
            filterOptions={filterOptions}
            // Ensures unique identification per option using its 'id' to fix keyboard navigation
            getOptionKey={(option) => option.id}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
                console.log(newValue);
                setSelectedProduct(newValue);
            }}
            getOptionLabel={(product) => product.title || "" }
            forcePopupIcon={false}
            className='bg-white'
            value={selectedProduct || null}
            renderInput={(params) => <TextField {...params} inputRef={focusInputRef} size="small" label="Select Product / Service" variant="standard" /> } 
        />
      </div>
      <div className='col-md-6'>
        <span className='mx-2'>OR</span>
        <ProductForm callBackWithId={onCreateNew} />
      </div>
    </div>
  )
}

export default SelectProduct